import { SubEntityType, Video } from '../../models';
import { knowledgeBaseHttp } from '../knowledge-base-api';

export const getVideos = async (groupId: number, locale: string): Promise<Video[]> => {
  try {
    const url = `/group/${groupId}/${SubEntityType.Videos}?marketLocale=${encodeURIComponent(locale)}`;
    const response = await knowledgeBaseHttp.get<Video[]>(url);
    return response?.data ?? [];
  } catch (error) {
    console.error(`Error fetching videos:`, error);
    return [];
  }
};
